"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-shield.tsx
var Shield = function Shield(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    d: "M18.2493 25.9167L27.666 16.5L25.291 14.125L18.2493 21.1667L14.7493 17.6667L12.3743 20.0417L18.2493 25.9167ZM19.9993 36.6667C16.1382 35.6945 12.9507 33.4792 10.4368 30.0209C7.92296 26.5625 6.66602 22.7223 6.66602 18.5V8.33337L19.9993 3.33337L33.3327 8.33337V18.5C33.3327 22.7223 32.0757 26.5625 29.5618 30.0209C27.048 33.4792 23.8605 35.6945 19.9993 36.6667ZM19.9993 33.1667C22.8882 32.25 25.2771 30.4167 27.166 27.6667C29.0549 24.9167 29.9993 21.8612 29.9993 18.5V10.625L19.9993 6.87504L9.99935 10.625V18.5C9.99935 21.8612 10.9438 24.9167 12.8327 27.6667C14.7216 30.4167 17.1105 32.25 19.9993 33.1667Z",
    fill: "currentColor"
  }));
};

var _default = Shield;
exports.default = _default;